<template>
  <v-alert border="top" colored-border type="info" elevation="2">
    Não há nenhum arquivo nesta pasta ainda :(<br />
    {{ addMessage }}
  </v-alert>
</template>

<script>
import { mapGetters } from 'vuex';
import { profiles } from '@/utils/Profiles';

export default {
  name: 'EmptyData',
  data: () => ({
    profiles,
  }),
  computed: {
    ...mapGetters({ user: 'user/getUser' }),
    addMessage() {
      return this.user.profile.id !== profiles.EDUCANDO &&
        this.user.profile.id !== profiles.USUARIO_EXTERNO
        ? 'Clique no botão de + para adicionar'
        : '';
    },
  },
};
</script>